import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type ConfiguratorModuleEmailContentsSetting } from '../../../../api/types';

export enum HeaderTabs {
    Vehicles = 'vehicles',
    FinanceProducts = 'financeProducts',
    MainDetails = 'mainDetails',
    Email = 'email',
}

export type ConfiguratorEmailFormValues = {
    saveOrder: ConfiguratorModuleEmailContentsSetting['saveOrder'] & {
        bannerImage?: File | UploadFileWithPreviewFormDataFragment;
        introImage?: File | UploadFileWithPreviewFormDataFragment;
    };
    submitOrder: ConfiguratorModuleEmailContentsSetting['submitOrder'] & {
        introImage?: File | UploadFileWithPreviewFormDataFragment;
    };
};

export type ConfiguratorModuleCounterKey =
    | 'applicationCounter'
    | 'reservationCounter'
    | 'leadCounter'
    | 'appointmentCounter'
    | 'insuranceCounter';
